import { render, staticRenderFns } from "./FormCOSCompliance.vue?vue&type=template&id=6d9d0abc&scoped=true&lang=pug"
import script from "./FormCOSCompliance.vue?vue&type=script&lang=ts"
export * from "./FormCOSCompliance.vue?vue&type=script&lang=ts"
import style0 from "./FormCOSCompliance.vue?vue&type=style&index=0&id=6d9d0abc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9d0abc",
  null
  
)

export default component.exports